import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Getter, Action, Mutation } from 'vuex-class'
import Modal from '@/components/modalBase/modalBase'
import CartList from '@/components/cart/cart'
import CommerceBanner from '@/components/commerceBanner/commerceBanner'

@Component({
  components: {
    Modal,
    CartList,
    CommerceBanner
  }
})
export default class ModalCar extends Vue {

  @Prop({ default: false }) show: any;

  @Getter getCartTemporal: any
  @Getter getCity: any
  @Getter getCountry: any
  @Getter getIsToken: any
  @Mutation PATH_TEMPORAL

  isBtnLoad = false

  get getProductsQty() {
    const cart = this.getCartTemporal
    if (cart.length) {
      let qty = 0
      cart.map((item) => {
        qty = item.qty + qty
      })
      return qty
    } else {
      return 0
    }
  }

  get getProductsTotal() {
    const cart = this.getCartTemporal
    if (cart.length) {
      let total = 0
      cart.map((item) => {
        const price = parseFloat(item.product.price)
        total = (price * item.qty) + total
      })
      return total.toLocaleString(this.getCountry.language, { style: 'currency', currency: this.getCountry.currency })
    } else {
      return 0
    }
  }

  get getCityReady() {
    return this.getCity && Object.keys(this.getCity).length > 0;
  }

  @Emit()
  onClose() {
  }

  keepBuying() {
    const query = this.$route.query;
    if (query.modalOpen) {
      this.$router.replace({ query: {} })
    }
    this.$emit('on-close');
  }

  @Emit()
  async onBtn() {
    this.$router.push({ name: 'checkout' })
  }

}
